<template>
    <div>
        <el-dialog
  title="选择分类"
  :visible.sync="dialogCategory"
  width="520px"
  :before-close="dialogClose"
  >
  <div class="box">
    <div class="search">
    <el-input v-model="searchInput" placeholder="请输入搜索分类名称"></el-input>
    </div>
    <div class="tree">
        <el-tree
        :filter-node-method="filterNode"
        @check-change="change"
        ref="tree"
         node-key="categoryCode"
  :data="treeData"
  :props="{
    label:'categoryName'
  }"
  show-checkbox>
</el-tree>
    </div>
    <div class="select">
        <div class="top" style="margin-bottom:5px">
            <span class="isSelcet">已选择 ({{tags.length}})</span>
            <span class="qk" @click="clear">清空</span>
        </div>
        <div>
            <el-tag
            class="mr5"
  v-for="tag in tags"
  :key="tag.categoryCode"
  closable
   @close="handleClose(tag)"
  type="info">
  {{tag.categoryName}}
</el-tag>
        </div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogClose">取 消</el-button>
    <el-button type="primary" @click="categoryBtn">确 定</el-button>
  </span>
</el-dialog>
    </div>
</template>

<script>
    export default {
            props:{
        categoryDialogVisible:{
            type: Boolean,
            default:false,
        },
        categorySelect:{
           type: Array,
           default:[],
        },
        categoryType:{
          type: String,
           default:'',
        }
     },
     watch:{
       'categoryDialogVisible' :{
      async  handler(v){
            deep:true,
            this.dialogCategory=v
            if(v){
                let res= await this.getTreeData()
                console.log(res,'获取了')
                console.log(this.categorySelect,'默认选择')
                let arrs=[]
                this.categorySelect.forEach(e=>{
                    arrs.push(e.categoryCode)
                })
                this.$refs.tree.setCheckedKeys([]);
                this.$refs.tree.setCheckedKeys(arrs);
            }
        }
       },
       searchInput(val){
         this.$refs.tree.filter(val)
       }
     },
        data(){
            return{
                dialogCategory:false,
                searchInput:'',//搜索内容
                treeData:[],//源数据
                tags:[],//当前选择
            }
        },
        methods:{
         filterNode(value, data) {
        if (!value) return true;
        return data.categoryName.indexOf(value) !== -1;
      },
        change(obj,flag){
        this.tags=this.$refs.tree.getCheckedNodes()
        // console.log(obj,flag,this.$refs.tree.getCheckedKeys())
        // console.log(this.$refs.tree.getCheckedNodes());
       },
        async  getTreeData(){ //获取菜品分类
        let res=await this.$http.post('/merchantProductsCategory/queryList',{merchantCode:localStorage.getItem('merchantCode')})
        this.treeData=res.data.data
       },
       handleClose(tag){
        let arr=[]
        this.tags.forEach(item=>{
            if(item.categoryCode!=tag.categoryCode){
                arr.push(item.categoryCode)
            }
        })
         this.$refs.tree.setCheckedKeys([]);
         this.$refs.tree.setCheckedKeys(arr);
        console.log(arr,tag)
       },
       clear(){
       this.$refs.tree.setCheckedKeys([]);
       },
       categoryBtn(){
        this.dialogCategory= false
        this.$emit('categorySumbit',this.tags,true)
       },
       dialogClose(){
        this.dialogCategory= false
        this.$emit('categorySumbit',this.tags,false)
       }
        },
        created(){
            this.getTreeData()
        }
    }
</script>

<style lang="scss" scoped>
.box{
    width: 100%;
    .search{
        padding: 10px;
    }
    .tree{
       max-height: 288px;
       overflow: auto;
    }
    .select{
        padding: 24px;
        border-top: 1px solid rgb(232, 232, 232);
        .top{
            display: flex;
            justify-content: space-between;
            .qk{
                color: rgb(255, 96, 0);
                cursor: pointer;
            }
        }
    }
}
/deep/ .el-dialog__header{
        padding: 16px 24px;
    color: rgb(51, 51, 51);
    background: rgb(255, 255, 255);
    border-bottom: 1px solid rgb(232, 232, 232);
    border-radius: 4px 4px 0px 0px;
}
/deep/.el-dialog__body{
    padding: 24px;
}
/deep/ .el-button--primary{
    background-color: rgb(255, 189, 0);
    border-color: rgb(255, 189, 0);
    color: #000;
}
 .mr5{
    margin-right: 5px;
    margin-bottom: 5px;
 }
</style>